function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6847_28558)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 11.5V6C15 2.68629 12.3137 0 9 0C5.68629 0 3 2.68629 3 6V11.5L0.5 15H17.5L15 11.5ZM9 18C10.1046 18 11 17.1046 11 16H7C7 17.1046 7.89543 18 9 18Z",
  fill: "#C4C4C4"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6847_28558"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "-9 -9 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9a842a5e43820220e27b453e1e9037a4.svg";
export { ForwardRef as ReactComponent };